<template>
  <el-card class="box-card">
    <el-form ref="formData" label-width="120px" class="demo-ruleForm">
      <el-row :gutter="24">
        <el-col :span="24" >
          <span >用户申请：</span>
        </el-col>
        <div v-for="(appsku,appindex) in formReturnData" style="border-bottom: 2px solid #f4f4f4;display: inline-block;margin-bottom: 20px;margin-top: 20px">
          <el-col :span="24">
            <div style="color:red">{{ appsku.cate_name }}</div>
          </el-col>
          <el-col :span="12" style="color:blue">
            <el-form-item label="申请sku：">
              <span>{{ appsku.sku }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请数量：">
              <span class="loadClass">{{ appsku.num }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物流单号：">
              <span>{{ appsku.recovery_order_express_num }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件人：">
              <span>{{ appsku.return_user_name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件电话：">
              <span>{{ appsku.return_user_mobile }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件地址：">
              <span>{{ appsku.return_user_address }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="">
              <el-checkbox v-model="appsku.return_check" :true-label="1" :false-label="0" @change="onchangeReturnAddress(appindex,appsku)"/>
            </el-form-item>
          </el-col>
        </div>
          <el-col :span="24">
            <el-form-item label="取件地址：">
              <el-input v-model="formStatusData.platform_address" type="text" size="mini" style="width: 400px"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="取件联系人：">
              <el-input v-model="formStatusData.platform_name" type="text" size="mini" style="width: 400px"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="取件联系电话：">
              <el-input v-model="formStatusData.platform_phone" type="text" size="mini" style="width: 400px"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="回寄地址：">
              <el-input v-model="formStatusData.user_address" type="text" size="mini" style="width: 400px"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="回寄联系人：">
              <el-input v-model="formStatusData.user_name" type="text" size="mini" style="width: 400px"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="回寄联系电话：">
              <el-input v-model="formStatusData.user_phone" type="text" size="mini" style="width: 400px"/>
            </el-form-item>
          </el-col>
        <el-col :span="24">
          <el-form-item label="" style="display: block;">
            <el-radio v-model="formStatusData.express_type" :label="1">自行寄件</el-radio>
            <el-radio v-model="formStatusData.express_type" :label="2">预约取件</el-radio>
          </el-form-item>
        </el-col>

        <el-col :span="24">
            <el-form-item label="选择物流：" style="display: block;">
              <el-select
                v-model="formStatusData.handle_express_number"
                clearable
                filterable
                placeholder="请选择"
                class="selWidth"
              >
                <el-option
                  v-for="item in express_company_list"
                  :key="item.express_number"
                  :label="item.express_name"
                  :value="item.express_number"
                />
              </el-select>
            </el-form-item>
          </el-col>
        <el-col :span="24" v-if="formStatusData.express_type == 1">
          <el-form-item label="物流单号：" style="display: block;">
            <el-input v-model="formStatusData.express_num" placeholder="请输入物流单号" style="width: 300px"></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="24" v-if="formStatusData.express_type == 2">
            <el-form-item label="预约取件时间：" style="display: block;">
              <el-select
                v-model="formStatusData.express_day_type"
                clearable
                filterable
                placeholder="请选择"
                class="selWidth"
                @change="change"
              >
                <el-option
                  v-for="item in expressDayTypeList"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="formStatusData.express_type == 2">
            <el-form-item label="预约取件时间范围：" style="display: block;">
              <el-time-select
                placeholder="起始时间"
                v-model="express_pickup_time.express_pickup_start "
                :picker-options="{
                  start: '06:00',
                  step: '01:00',
                  end: '22:00',
                  minTime:minTime,
                  maxTime:'22:00'
                }"
              >
              </el-time-select>
              -
              {{timeEndFn}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">提交</el-button>
            </el-form-item>
          </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {userOrderApi, userDetailApi, userCouponApi, userBillApi, modifyUserRefLog} from '@/api/user'
import {
  recoveryOrderDetailApi,
  recoveryOrderListApi, recoveryOrderReturnApi, recoveryOrderReturnHandleSublimitApi,
  recoveryOrderUpdateSublimitApi,
  recoveryOrderWoreHandleSublimitApi
} from "@/api/recovery";

export default {
  name: 'OrderReturnHandle',
  props: {
    recovery_order_id: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      minTime:'',
      moren: require("@/assets/images/f.png"),
      loading: false,
      columns: [],
      Visible: false,
      formStatusData: {
        express_day_type: '',
        express_type:1,
        express_num:'',
      },
      formReturnData:[],
      sublimeData:{},
      order_return_id:[],

      express_pickup_time: {
        express_pickup_start:'',
        express_pickup_end:''
      },
      expressDayTypeList: [
        '今天', '明天', '后天'
      ],
      express_company_list:[
        {'express_number':'jd',
        'express_name':'京东'},
        {'express_number':'debangkuaidi',
          'express_name':'德邦'},

      ],
      psInfo: null,
      type: '0'
    }
  },
  computed:{
    timeEndFn(){
      if(this.express_pickup_time.express_pickup_start){
        let t=parseInt(this.express_pickup_time.express_pickup_start.split(':')[0])
        if(t<9){
          this.express_pickup_time.express_pickup_end='0'+(t+1)+':00'
          return '0'+(t+1)+':00'
        }else{
          this.express_pickup_time.express_pickup_end=(t+1)+':00'
          return (t+1)+':00'
        }
      }else{
        return '结束时间为开始时间1小时之后'
      }

    }
  },
  mounted() {
    if (this.recovery_order_id) {
      this.getInfo('0')
    }
  },
  methods: {
    onchangeReturnAddress(index,row) {
      this.recovery_price_total = 0;
      this.recovery_num_total = 0;
      this.formReturnData.forEach((iteme,indexe)=> {
          if(iteme.return_check == 1 && indexe != index) {
            if(iteme.return_user_address !=  row.return_user_address || iteme.return_user_mobile !=  row.return_user_mobile)
            {
              iteme.return_check = 0
              this.$message.error('地址电话不同不可以一起邮寄，请重新选择');
            }
          }
      })
      this.formStatusData.user_address = row.return_user_address
      this.formStatusData.user_name = row.return_user_mobile
      this.formStatusData.user_phone = row.return_user_name
    },
    change(e){
      this.express_pickup_time.express_pickup_start=''
      if(e=='今天'){
        this.minTime=new Date().getHours()+':00'
      }else{
        this.minTime=''
      }
    },
    getInfo() {
      this.loading = true
      recoveryOrderReturnApi(this.recovery_order_id).then((res) => {
        this.formStatusData = {...res.data.recoveryOrder,...this.formStatusData}
        this.formReturnData = res.data.returnList
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onSubmit() {
      this.order_return_id = [];
      this.formReturnData.forEach((item) => {
        if(item.return_check == 1) {
          this.order_return_id.push(item.recovery_order_return_id)
        }
      })
      console.log(this.order_return_id)
      if(this.order_return_id.length <= 0)
      {
        this.$message.error('请选择需要退回的商品')
        return false
      }
      this.sublimeData.order_return_id = this.order_return_id
      this.sublimeData.handle_express_number = this.formStatusData.handle_express_number
      this.sublimeData.express_day_type = this.formStatusData.express_day_type
      this.sublimeData.user_phone = this.formStatusData.user_phone
      this.sublimeData.user_name = this.formStatusData.user_name
      this.sublimeData.user_address = this.formStatusData.user_address
      this.sublimeData.platform_phone = this.formStatusData.platform_phone
      this.sublimeData.platform_name = this.formStatusData.platform_name
      this.sublimeData.platform_address = this.formStatusData.platform_address
      this.sublimeData.express_num = this.formStatusData.express_num
      this.sublimeData.express_type = this.formStatusData.express_type
      console.log(this.formStatusData)
      this.sublimeData={...this.sublimeData,...this.express_pickup_time}
      if(this.formStatusData.express_type==2){
        this.sublimeData.express_num = ''
        console.log(this.sublimeData.express_day_type ,  this.sublimeData.express_pickup_end , this.sublimeData.express_pickup_start)
        if(!this.sublimeData.express_day_type ||  !this.sublimeData.express_pickup_end || !this.sublimeData.express_pickup_start)
        {
          this.$message.error('请选择退回时间')
          return false
        }
      }
      if(!this.sublimeData.user_phone)
      {
        this.$message.error('请填写退回手机号')
        return false
      }
      if(!this.sublimeData.user_name)
      {
        this.$message.error('请填写退回联系人')
        return false
      }
      if(!this.sublimeData.user_address)
      {
        this.$message.error('请填写退回地址')
        return false
      }

      if(!this.sublimeData.handle_express_number)
      {
        this.$message.error('请选择物流')
        return false
      }

      recoveryOrderReturnHandleSublimitApi(this.formStatusData.recovery_order_id, this.sublimeData).then(res => {
        this.$message.success(res.message)
        this.dialogVisibleStatus = false
        this.$emit("sendSuccess");
        this.minTime=''
        this.express_pickup_time= {
          express_pickup_start:'',
            express_pickup_end:''
        }
      }).catch(res => {
        this.$message.error(res.message)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.box-card .el-form-item {
  margin-bottom: 0;
}

.has-bot .el-form-item {
  margin-bottom: 20px;
}

.avatar {
  width: 60px;
  height: 60px;
  margin-left: 18px;

  img {
    width: 100%;
    height: 100%;
  }
}
.loadClass{
  font-weight: bold;
  color: red;
  font-size: 16px;
}
.dashboard-workplace {
  &-header {
    &-avatar {
      /*width: 64px;*/
      /*height: 64px;*/
      /*border-radius: 50%;*/
      margin-right: 16px;
      font-weight: 600;
    }

    &-tip {
      width: 82%;
      display: inline-block;
      vertical-align: middle;
      margin-top: -12px;

      &-title {
        font-size: 13px;
        color: #000000;
        margin-bottom: 12px;
      }

      &-desc {
        &-sp {
          width: 32%;
          color: #17233D;
          font-size: 13px;
          display: inline-block;
        }
      }
    }

    &-extra {
      .ivu-col {
        p {
          text-align: right;
        }

        p:first-child {
          span:first-child {
            margin-right: 4px;
          }

          span:last-child {
            color: #808695;
          }
        }

        p:last-child {
          font-size: 22px;
        }
      }
    }
  }
}
</style>
